const Row = ({ children }) => {
    return (
        <div className="main-content__form-row">
            {children}
        </div>
    );
};

export default Row;
